import { render, staticRenderFns } from "./fccProjetos.vue?vue&type=template&id=057f65ea"
import script from "./fccProjetos.vue?vue&type=script&lang=js"
export * from "./fccProjetos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports